const faker = require('faker');
import { Factory } from 'miragejs'

export const awardFactory = Factory.extend({
  slug() {
    return faker.lorem.slug()
  },
  name() {
    return faker.company.companyName()
  },
  description() {
    return faker.lorem.paragraph()
  },
  logo() {
    return faker.image.imageUrl()
  },
  logo_negative() {
    return faker.image.imageUrl()
  },
  colors: {
    primary: faker.internet.color(),
  },
  categories() {
    return [
      {
        id: faker.datatype.uuid(),
        name: faker.commerce.department(),
        slug: faker.lorem.slug()
      }
    ]
  },
  campaigns() {
    const campaign = () => ({
      id: faker.datatype.uuid(),
      name: faker.commerce.productName(),
      title: faker.company.catchPhrase(),
      description: faker.lorem.paragraph(),
      important: faker.company.catchPhrase(),
      slug: faker.lorem.slug(),
      howtouse: [ faker.lorem.paragraph(), faker.lorem.paragraph() ],
      end_date: null,
      favorired: faker.datatype.boolean(),
      liked: faker.datatype.boolean(),
      event: 'award',
      symbol: null,
      value: null,
      voucher: null,
      partner_slug: faker.lorem.slug(),
      eventData: {
        price: null,
        value: faker.datatype.number({ min: 1, max: 100 }),
        min_value: null,
        max_value: null,
        prices_options: null
      }
    })
    return Array.from({ length: faker.datatype.number({ min: 1, max: 5 }) }, campaign)
  }
})



// WEBPACK FOOTER //
// ./src/mocks/factories/awardFactory.js